import { useEffect } from 'react';
import { consoleWarn } from '@hse-design/core';

export function useWarnMessage(message: string, when: boolean, component?: any) {
  useEffect(() => {
    if (when) {
      consoleWarn(message, component);
    }
    // Нас интересуют только актуальные message и component в момент когда when=true
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [when]);
}
